import React, {Component} from 'react';
import {DocumentTitle} from '../widgets';
import NewsCard from '../home/NewsCard';
import './NewsPress.css';
import {fetchJson} from '../fetchJson';

class Events extends Component {
	constructor() {
		super();

		this.state = {events: []};
	}

	componentDidMount() {
		fetchJson('https://b2me.com.au/b2meevents/events.json')
			.then(events => this.setState({events}))
			.catch(this.props.handleError); // Ignore
	}

	render() {
		const {events} = this.state;
		return (
			<DocumentTitle title="B2Me">
				<main className="NewsPress">
					<div className="NewsSection">
						<ul>
							{events.map(item => (
								<li key={`${item.formattedDate}_${item.title}`}>
									<NewsCard
										href={item.href}
										thumbnailSrc={item.thumbnailSrc}
										title={item.title}
										vendor={item.vendor}
										formattedDate={item.formattedDate}
										description={item.description}
									/>
								</li>
							))}
						</ul>
					</div>
				</main>
			</DocumentTitle>
		);
	}
}

export default Events;



// WEBPACK FOOTER //
// ./src/pages/Events.js